import { useTranslation } from 'react-i18next';
import PageHeader from '@casops/components/layout/page-header/PageHeader';
import { ModelName, QueryTag, TagList } from '@casops/store/api';
import StandardPage from '@casops/templates/standard-page/StandardPage';
import { CollectionView } from '@casops/components/layout/collection-view/CollectionView';
import { useTableData } from '@casops/shared/hooks/useTableData';
import {
  DeviceMessageModel,
  useGetListDeviceMessagesQuery,
} from '@casops/store/apis/deviceMessagesApi';
import { useDeviceMessagesColumnDefs } from '@casops/hooks/useDeviceMessagesColumnDefs';

type Model = DeviceMessageModel;

const modelName = ModelName.DeviceMessage;
const diagnosticModelName = ModelName.Diagnostic;

const API_TABLE_LIMIT = 50;

const tagsToClearOnRefresh = [{ type: QueryTag.DeviceMessage, id: TagList }];

export function DiagnosticsPage() {
  const { t } = useTranslation();

  const columnDefs = useDeviceMessagesColumnDefs(true);

  const noResultsDescription = t('Model.Collection.NoItems', { modelName });

  const { data, ...requestRemainder } = useGetListDeviceMessagesQuery(undefined, {
    refetchOnMountOrArgChange: 60,
  });

  const { hasData, noDataDescription } = useTableData<Model>({
    data,
    ...requestRemainder,
    noResultsDescription,
  });

  return (
    <StandardPage
      header={
        <PageHeader
          title={t('Model.Collection.Title', { modelName: diagnosticModelName })}
          tagsToClearOnRefresh={tagsToClearOnRefresh}
        />
      }
    >
      <CollectionView<Model>
        sliceKey={modelName}
        modelName={modelName}
        columnDefs={columnDefs}
        rowData={data}
        hasData={hasData}
        noDataDescription={noDataDescription}
        apiResultLimit={API_TABLE_LIMIT}
      />
    </StandardPage>
  );
}

export default DiagnosticsPage;
